import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import ReportFilters from './ReportFilters';
import ReportToolbar from './ReportToolbar';


const useStyles = makeStyles(theme => ({
    paper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    },
    table: {
        minWidth: 650,
    },
    tableHeader: {
        backgroundColor: theme.palette.primary.main,
        '& .MuiTableCell-head': {
            color: theme.palette.primary.contrastText,
        },
    },
    positiveNumber: {
        color: theme.palette.primary.main,
    },
}));

const VenuesReport = () => {
    const classes = useStyles();
    const reportUrl = '/api/reports/venues';
    const reportTitle = 'Venues Report';
    const pageTitle = `${reportTitle} - Enduring Promises`;
    const [data, setData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    const [state, setState] = React.useState({
        year: new Date().getFullYear(),
        search: '',
    });

    const getData = state => {
        new Promise((resolve, reject) => {
            fetch(`${reportUrl}?year=${state.year}&search=${state.search}`)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setData(result);
                    resolve();
                })
                .finally(() => {
                    setLoading(false);
                });
        });
    };

    useEffect(() => {
        document.title = pageTitle;
        getData(state);
    }, [1]);

    const handleSubmit = () => {
        getData(state);
    };

    const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    const totals = Array.from({length: 13}, (x,i) => 0);

    const getClass = count => {
        return count > 0 ? classes.positiveNumber : '';
    }

    const csvData = (data) => {
        const rows = [];
        const totals = Array.from({length: 12}, (x,i) => 0);
        let total = 0;
        Object.values(data).forEach(row => {
            let subTotal = Object.values(row.data).reduce((x,y) => x + y);
            total += subTotal;
            Object.values(row.data).map((x,i) => totals[i] += x);
            rows.push([row.title, ...Object.values(row.data), subTotal]);
        });
        rows.push(['', ...totals, total]);
        return {
            filename: 'venues-report.csv',
            columns: ["Venue", ...months, "Total"],
            rows,
        }
    }

    return (
        <Paper square className={classes.paper}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">{reportTitle}</Typography>
                </Grid>
                <Grid item xs={8}>
                    <ReportFilters state={state} setState={setState} handleSubmit={handleSubmit} />
                </Grid>
                <Grid item xs={4}>
                    <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                    >
                        {data !== null && <ReportToolbar data={csvData(data)} />}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper} variant="outlined" square>
                        <Table className={classes.table} size="small">
                            <TableHead className={classes.tableHeader}>
                                <TableRow>
                                    <TableCell align="left">Venue</TableCell>
                                    {months.map((month,k) => (
                                        <TableCell align="center" key={k}>{month}</TableCell>
                                    ))}
                                    <TableCell align="center">Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {!loading && data !== null && Object.values(data).map((row, i) => {
                                let subTotal = 0;
                                return (
                                    <TableRow key={`row-${i}`}>
                                        <TableCell align="left">{row.title}</TableCell>
                                        {Object.values(row.data).map((count,k) => {
                                            subTotal += count;
                                            totals[k] += count;
                                            totals[12] += count;
                                            return (
                                                <TableCell align="center" key={k}><span className={getClass(count)}>{count}</span></TableCell>
                                            )
                                        })}
                                        <TableCell align="center">{<span className={getClass(subTotal)}>{subTotal}</span>}</TableCell>
                                    </TableRow>
                                )
                            })}
                            {!loading && data !== null && Object.values(data).length > 0 && (
                                <TableRow>
                                    <TableCell></TableCell>
                                    {totals.map((count,key) => (
                                        <TableCell align="center" key={`totals-${key}`}><span className={getClass(count)}>{count}</span></TableCell>
                                    ))}
                                </TableRow>
                            )}
                            {!loading && data !== null && data.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={14} align="center">No data</TableCell>
                                </TableRow>
                            )}
                            {loading && (
                                <TableRow>
                                    <TableCell colSpan={14} align="center">
                                        <CircularProgress color="primary" />
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default VenuesReport;
